export function parseExtId(str) {
  const trimmedStr = str.trim();
  if(trimmedStr.length === 0) {
    return [null, 'Ext id must be specified.'];
  }

  const parts = trimmedStr.split(':');
  if(parts.length !== 2) {
    return [null, `String '${trimmedStr}' is not valid ext id. Invalid part amount.`];
  }

  if(!isPlatformPrefix(parts[0])) {
    return [null, `String '${trimmedStr}' is not valid ext id. Invalid platform prefix '${parts[0]}'.`];
  }

  const code = parts[1];
  if(code.length === 0) {
    return [null, `String '${trimmedStr}' is not valid ext id. Code part must be specified.`];
  }

  // Допустимые символы:
  // ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
  const isCodePartValid = /^[A-Za-z0-9+/=]+$/.test(code)
  if(!isCodePartValid) {
    return [null, `String '${trimmedStr}' is not valid ext id. Code part is invalid.`];
  }

  return [trimmedStr, null];
}

function isPlatformPrefix(str) {
  const platformPrefixes = [
    "ios",
    "and",
    "amz",
    "sam",
    "hua",
  ];

  for(const platformPrefix of platformPrefixes) {
    if(str === platformPrefix) {
      return true
    }
  }
  return false
}
